<template>
  <div @click="landingPage"><img id="logo" src="/static/images/xm_logo.png" alt="logo" /></div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Logo",
  props: ["disabled"],
  data() {
    return {};
  },
  methods: {
    landingPage(path) {
      if (this.disabled) return;
      if (this.insightsEnabled) {
        this.$router.push("/home");
      } else {
        this.$router.push("/dashboard");
      }
    }
  },
  computed: {
    ...mapGetters(["insightsEnabled"])
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";

.material-icons {
  font-size: inherit;
}

@media (max-width: 768px) {
  .box-logo {
    .collapse-nav {
      display: none;
    }

    &.horizontal {
      padding: 0 10px;

      .app-name {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Logo.vue